import { render, staticRenderFns } from "./TableEventsCategory.vue?vue&type=template&id=3f66b5fe&scoped=true&"
import script from "./TableEventsCategory.vue?vue&type=script&lang=js&"
export * from "./TableEventsCategory.vue?vue&type=script&lang=js&"
import style0 from "./TableEventsCategory.vue?vue&type=style&index=0&id=3f66b5fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f66b5fe",
  null
  
)

export default component.exports